// export const PRIMARY_MAIN_COLOR = "#305E9B";
// export const PAPER_MAIN_COLOR = "#FFFFFF";
export const DEFAULT_COLOR = "#FFFFFF"; //white
export const DEFAULT_ORANGE = "#FF8C00";

export const COLORS = {
  blue_gradients: {
    blue: "#0F64D5", //used in charts
    light: "#83B8FF", //used in charts
    // transparent: "#0F64D5"
  },
  black_gradients: {
    greyLight: "#F6F8FA",
    greyOne: "#8E8E93",
    greyTwo: "#6B7281",
    black: "#1A1A1A",
  },
  red_gradients: {
    red: "#FF4545",
    redLight: "#FF6464", //used in charts
  },
  yellow_gradients: {
    yellow: "#FFE55D", //used in charts
  },
  green_gradients: {
    green: "#17CE71",
    greenExcel: "#1D6F42",
    darkGreen: "#006400",
  },
  purple_gradients: {
    purple: "#BF40BF",
  },
};

export const FONT_SIZES = {
  sizeOne: {
    text: "11px",
    number: 10,
  },
  sizeTwo: {
    text: "12px",
    number: 12,
  },
  sizeThree: {
    text: "14px",
    number: 14,
  },
  sizeFour: {
    text: "16px",
    number: 16,
  },
  sizeFive: {
    text: "21px",
    number: 21,
  },
  sizeSix: {
    text: "24px",
    number: 24,
  },
  sizeSeven: {
    text: "28px",
    number: 28,
  },
};

export const SPACING = [
  3, //0
  5, //1
  8, //2
  10, //3
  12, //4
  15, //5
  18, //6
  20, //7
  22, //8
  24, //9
  25, //10
];
